

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const bankingAtomList = atom({key:'bankingAtom', default:{bank_info:[],
    cash_bank_balance_info:[], currency_info:[]
}});





export  const SetBankingList = () => useSetRecoilState(bankingAtomList);
export  const GetBankingList = () => useRecoilValue(bankingAtomList);

// export  const SetStockAdjustmentEdit = () => useSetRecoilState(stockEditAtom);
// export  const GetStockAdjustmentEdit = () => useRecoilValue(stockEditAtom);








